exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-detail-js": () => import("./../../../src/pages/detail.js" /* webpackChunkName: "component---src-pages-detail-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-weartek-4836-index-js": () => import("./../../../src/pages/weartek-4836/index.js" /* webpackChunkName: "component---src-pages-weartek-4836-index-js" */),
  "component---src-pages-weartek-zero-index-js": () => import("./../../../src/pages/weartek-zero/index.js" /* webpackChunkName: "component---src-pages-weartek-zero-index-js" */)
}

